<template>
  <div class="homepage">

    <div class="homepage__description">
      <div class="homepage__title">
        SET YOUR FIRST ALERT HERE
      </div>
      <head-title class="head-title">
        Alert me when <span @click="increaseParameterIndex" class="parameter-options">{{leaderTickerName}} {{form.valueType.value}}</span>
        <br class="text-break text-break_top">
        will be <span @click="increaseConditionIndex">{{alertType.text}}</span><br class="text-break text-break_bottom"> than
        <span class="set-alert-value">{{calculatedAlertValue | formatMoney(currencyCode)}}</span>
      </head-title>
      <button-el :disabled="!leaderTicker" @click.native="setAndOpenAlertCreation" class="homepage__free-alert-btn">
        set free alert
      </button-el>
    </div>

    <div class="how-it-works" ref="chartSection">
      <head-title class="how-it-works__title">How it works</head-title>

      <div class="how-it-works__graph" ref="chart">
        <div class="how-it-works__grids">
          <alert-line
            class="alert-line"
            :class="{'alert-line_animate': chartAnimate, 'alert-line_show': justShowChart}"
          />
        </div>
      </div>

    </div>

    <div class="cards">

      <div
        @click="toggleAlertsCardEffect"
        class="card__wrapper"
      >
        <div
          class="card card_alerts"
          :class="{'card_show-effect': showAlertsCardEffect, 'card_is-touched': isTouchEnabled}"
        >
          <div class="card__title">Alerts</div>
            <div class="card__notice">
              <b>useful</b><br> and <b>customizable</b>
            </div>
            <div class="card__frame-btc"></div>
            <div class="card__frame-ltc"></div>
        </div>
        <div class="card__overlay"></div>
      </div>

      <div
        class="card__wrapper"
        @click="toggleMultipleWaysCardEffect"
      >
        <div
          class="card card_multiple-ways"
          @mouseover="removeBgWebAlert"
          :class="{
              'remove-bg': removeBg,
              'card_show-effect': showMultipleWaysCardEffect,
              'card_is-touched': isTouchEnabled
            }"
        >
          <div class="card__title">Multiple ways</div>
            <div class="card__notice">to <b>receive</b> alerts</div>
            <icon-sms class="icon-sms">SMS</icon-sms>
            <icon-web-alert class="icon-web-alert">webalert</icon-web-alert>
            <icon-hook class="icon-hook">webhook</icon-hook>
        </div>
        <div class="card__overlay"></div>
      </div>

      <div
        class="card__wrapper"
        @click="toggleMarketAnalyticsCardContent"
      >
        <div
          class="card card_market-analytics"
          :class="{'card_show-effect': showMarketAnalyticsCardEffect, 'card_is-touched': isTouchEnabled}"
        >
          <div class="card__title">Market analytics</div>
          <div class="card__notice">free weekly</div>
          <div class="card__market-frame"></div>
          <div class="card__ripple-frame"></div>
          <div class="card__news-rising"></div>
        </div>
        <div class="card__overlay"></div>
      </div>
    </div>

    <div class="cover">
      <div class="cover__wrap">
        <div class="cover__alert">
          <div class="cover__hand">
            <div class="cover__red-circle"></div>
          </div>
          <pulsar-el/>
        </div>
        <div class="cover__description">
          <div class="cover__title">
            <div class="cover__title_red">Covers</div> you
            everywhere
          </div>
          <div class="cover__notice">
            Cryptoalerts always keeps you updated in every situation and at any time, even when you're not expecting it. You can forget about risks, but Cryptoalerts doesn't
          </div>
          <button class="cover__btn" @click="onClickSignUp">
            <div class="pulsar-circle"></div>
            <div class="cover__btn-text">Sign Up</div>
          </button>
        </div>
      </div>
    </div>

    <div class="control">
      <div class="control__description">
        <div class="control__title">
          <div class="control__title_red">All</div> is under control
        </div>
        <div class="control__notice">
          Cryptoalerts monitors the maximum number of currencies and many other statistics. Keep your finger on the pulse and be confident with your decisions depending on the market situation
        </div>
      </div>

      <div class="control__overview">
        <div class="control__overview-volume">
          <img class="control__overview-graph" :src="`${apiUrl}/images/global/sparkline/total_volume24h/${currencyCode}/preview.svg?color=ffffff`">
          <div class="control__overview-value">${{totalVolume24h | getValueForCurrencyCode(currencyCode) | formatMarketValue}}</div>
          <div class="control__overview-title">24H MARKET TRADE VOLUME</div>
        </div>

        <div class="control__overview-market-cap">
          <img class="control__overview-graph" :src="`${apiUrl}/images/global/sparkline/total_market_cap/${currencyCode}/preview.svg?color=ffffff`">
          <div class="control__overview-value">${{totalMarketCap | getValueForCurrencyCode(currencyCode) | formatMarketValue}}</div>
          <div class="control__overview-title">TOTAL MARKET CAP</div>
        </div>

        <div class="total-currencies">
          <div class="total-currencies__value">{{totalRowsCount}}+</div>
          <div class="total-currencies__notice">Cryptoalerts tracks all known cryptocurrencies and searches for those recently added</div>
          <div class="total-currencies__title">TOTAL TRACKED CURRENCIES</div>
        </div>
      </div>

      <div class="gainers-losers">
        <table class="gainers-losers__table">
          <tr v-for="currency in mostChangedTickersList" :key="currency.id">
            <td
              class="gainers-losers__td gainers-losers__type"
              :class="{'gainers-losers__percent_red': !checkCurrencyOnPositive(currency.percentChange24hUSD)}"
            >
            24H
            </td>
            <td class="gainers-losers__td gainers-losers__name" :title="currency.name">
              {{currency.name}}
            </td>
            <td class="gainers-losers__td gainers-losers__percent">
              <icon-tendency-arrow :up="checkCurrencyOnPositive(currency.percentChange24hUSD)" class="icon-arrow"/>
              {{currency.percentChange24hUSD | formatPercentValue}}
            </td>
          </tr>
        </table>
        <div class="gainers-losers__label">GAINERS & LOSERS</div>
      </div>

      <div class="recently-added">
        <table class="recently-added__table">
          <thead>
            <tr>
              <th class="recently-added__th recently-added__th_added">Added</th>
              <th class="recently-added__th recently-added__th_name">Name</th>
              <th class="recently-added__th recently-added__th_symbol">Symbol</th>
              <th class="recently-added__th recently-added__th_price">Price</th>
              <th class="recently-added__th recently-added__th_volume">Volume (24H)</th>
              <th class="recently-added__th recently-added__th_percent">Price, 24h</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="currency in recentlyAddedList" :key="currency.id">
              <td class="recently-added__td recently-added__type">
              {{currency.createdAt | formatDate}}
              </td>
              <td class="recently-added__td recently-added__name" :title="currency.name">
                {{currency.name}}
              </td>
              <td class="recently-added__td recently-added__symbol">{{currency.symbol}}</td>
              <td class="recently-added__td recently-added__price" :title="currency.priceUSD | formatMoney(currencyCode)">
                {{currency.priceUSD | formatMoney(currencyCode)}}
              </td>
              <td class="recently-added__td recently-added__volume" :title="currency.marketVol24hUSD | beautifyVolumeValue">
                {{currency.marketVol24hUSD | beautifyVolumeValue}}
              </td>
              <td class="recently-added__td recently-added__percent">
                <icon-tendency-arrow class="icon-arrow" :up="checkCurrencyOnPositive(currency.percentChange24hUSD)"/>
                {{currency.percentChange24hUSD | formatPercentValue}}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="recently-added__label">RECENTLY ADDED</div>
      </div>

    </div>

    <currencies-table landingPageVersion class="currencies"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import differenceInDays from 'date-fns/difference_in_days';
import { formatMoney, roundingValue, formatPercentValue, getValueForCurrencyCode } from 'src/utils/helpers';
import { apiUrl } from 'src/utils/config';
import saveAlertDataToLocalStorageMixin from 'src/mixins/saveAlertDataToLocalStorage';
import { setAlertOptions, lowerText } from 'src/models/AlertsConditionTypes';
import { valueTypes } from 'src/models/AlertsValueTypes';
import loginModalTabs from 'src/models/LoginModalTabs';
import AlertCreationForm from 'src/models/AlertCreationForm';
import { IconTendencyArrow, IconSms, IconHook, IconWebAlert } from 'Icons';
import currenciesTable from 'Common/currenciesTable';
import AlertLine from './AlertLine';
import PulsarEl from './PulsarEl';

export default {
  name: 'HomePage',
  mixins: [
    saveAlertDataToLocalStorageMixin,
  ],
  components: {
    currenciesTable,
    AlertLine,
    IconSms,
    IconHook,
    IconWebAlert,
    IconTendencyArrow,
    PulsarEl,
  },
  data: () => ({
    chartAnimate: false,
    justShowChart: false,
    removeBg: false,
    loginModalTabs,
    alertParameterIndex: 0,
    alertConditionIndex: 0,
    showAlertsCardEffect: false,
    showMultipleWaysCardEffect: false,
    showMarketAnalyticsCardEffect: false,
  }),
  methods: {
    ...mapActions('settings', ['toggleLoginModal']),
    ...mapActions('tickers', [
      'getMostChangedTickersList',
      'getRecentlyAddedList',
      'getLeaderTicker',
    ]),
    setAndOpenAlertCreation() {
      this.saveAlertDataToLocalStorage(this.form, this.leaderTicker.id);
      this.$router.push(`/add-alert/${this.leaderTicker.id}`);
    },
    onClickSignUp() {
      this.$router.push('/authorization-page/sign-up');
      this.toggleLoginModal({ val: false, activeTab: loginModalTabs.register });
    },
    checkVisibilityGraphSection() {
      const heightChart = this.$refs.chart.clientHeight;
      const topCoordinateChart = this.$refs.chartSection.getBoundingClientRect().top;
      const windowOffset = window.pageYOffset;
      const bottomChartCoordinate = topCoordinateChart - heightChart;
      const windowHeight = document.documentElement.clientHeight;
      const chartIsVisible = this.$refs.chartSection.getBoundingClientRect().bottom <= windowHeight;
      if (((bottomChartCoordinate) <= windowOffset) || chartIsVisible) {
        this.chartAnimate = true;
      }
    },
    checkCurrencyOnPositive(value) {
      return value > 0;
    },
    removeBgWebAlert() {
      this.removeBg = true;
    },
    getNextIndex(arr, index) {
      const indexIsLast = (arr.length - 1) <= index;
      return indexIsLast ? 0 : index + 1;
    },
    increaseParameterIndex() {
      this.alertParameterIndex = this.getNextIndex(this.valueTypes, this.alertParameterIndex);
    },
    increaseConditionIndex() {
      this.alertConditionIndex = this.getNextIndex(this.setAlertOptions, this.alertConditionIndex);
    },
    toggleAlertsCardEffect() {
      this.showAlertsCardEffect = !this.showAlertsCardEffect;
    },
    toggleMultipleWaysCardEffect() {
      this.showMultipleWaysCardEffect = !this.showMultipleWaysCardEffect;
    },
    toggleMarketAnalyticsCardContent() {
      this.showMarketAnalyticsCardEffect = !this.showMarketAnalyticsCardEffect;
    },
  },
  computed: {
    ...mapState('userData', ['loginInfo']),
    ...mapState('tickers', [
      'mostChangedTickersList',
      'recentlyAddedList',
      'totalRowsCount',
      'totalMarketCap',
      'totalVolume24h',
      'leaderTicker',
    ]),
    ...mapGetters('userData', ['currencyCode']),
    leaderTickerName() {
      return this.leaderTicker ? this.leaderTicker.name : 'Bitcoin';
    },
    valueTypes: () => valueTypes, // eslint-disable-line
    setAlertOptions: () => setAlertOptions, // eslint-disable-line
    apiUrl: () => apiUrl,
    alertType() {
      return setAlertOptions[this.alertConditionIndex];
    },
    form() {
      return new AlertCreationForm(
        this.alertType.type,
        this.alertType.direction,
        valueTypes[this.alertParameterIndex],
        null,
        false,
        false,
        false,
        false,
        '10',
        '',
      );
    },
    calculatedAlertValue() {
      const lowerIsSet = setAlertOptions[this.alertConditionIndex].text === lowerText;
      const coefficient = lowerIsSet ? 0.9 : 1.1;
      return roundingValue((this.setAlertValue[this.alertParameterIndex] * coefficient), 2);
    },
    setAlertValue() {
      if (!this.leaderTicker) {
        return [11415.7, 109001577252, 4687680000];
      }
      const { priceUSD, marketCapUSD, marketVol24hUSD } = this.leaderTicker;
      return [priceUSD, marketCapUSD, marketVol24hUSD];
    },
    isTouchEnabled() {
      return !!('ontouchstart' in window) || false;
    },
  },
  filters: {
    getValueForCurrencyCode,
    formatPercentValue,
    formatMoney,
    beautifyVolumeValue(val) {
      return formatMoney(roundingValue(+val, 2));
    },
    formatMarketValue(val) {
      return String(roundingValue(+val, 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatDate(val) {
      const diff = Math.abs(differenceInDays(val, new Date()));
      if (diff <= 1) {
        return '1D';
      }
      return `${diff}D`;
    },
  },
  created() {
    this.getMostChangedTickersList();
    this.getRecentlyAddedList();
    if (!this.leaderTicker) {
      this.getLeaderTicker();
    }
    window.addEventListener('load', this.checkVisibilityGraphSection);
    if (this.isTouchEnabled) {
      window.addEventListener('touchmove', this.checkVisibilityGraphSection);
    } else {
      window.addEventListener('wheel', this.checkVisibilityGraphSection);
    }
  },
  beforeDestroy() {
    window.removeEventListener('load', this.checkVisibilityGraphSection);
    if (this.isTouchEnabled) {
      window.removeEventListener('touchmove', this.checkVisibilityGraphSection);
    } else {
      window.removeEventListener('wheel', this.checkVisibilityGraphSection);
    }
  },
  watch: {
    loginInfo(token) {
      if (token) {
        this.$router.replace('/all-currencies');
      }
    },
  },
};
</script>


<style lang="scss" scoped>
  $container-width: 1100px;
  .homepage {
    padding-top: 180px;
    position: relative;
    background: $red-color3;
    box-shadow: inset 0 7px 10px $black-color6;
    // TODO add circles when will do animation
    background-position: 31.8% -12.2%;
    &__description {
      text-align: center;
    }
    &__title {
      @include font(16px, $white-color2, 500);
    }
    .head-title {
      @include font(48px, $white-color2, 600);
      line-height: 56px;
      margin: 30px auto;
      user-select: none;
      span {
        cursor: pointer;
        color: $red-color9;
        text-decoration: none;
        position: relative;
        padding-bottom: 4px;
        display: inline-block;
        text-transform: lowercase;
        &.parameter-options {
          &::first-letter {
            text-transform: uppercase;
          }
        }
        &.set-alert-value {
          cursor: inherit;
          &:after {
            content: none;
          }
        }
        &:after {
          content: '';
          position: absolute;
          border-bottom: 1px dashed $black-color7;
          width: 100%;
          left: 0;
          bottom: 0;
        }
      }
    }

    .homepage__free-alert-btn {
      background: $white-color2;
      border: none;
      margin-top: 13px;
      padding: 23px 0 22px;
      max-width: 175px;
      margin-bottom: 143px;
      font-size: 14px;
      &:hover {
        background: $red-color9;
        color: $white-color2;
      }
    }

    .how-it-works {
      text-align: center;
      margin-bottom: 156px;
      &__title {
        @include font(42px, $white-color2, bold);
      }
      &__graph {
        width: 718px;
        height: 269px;
        margin: 60px auto 100px;
        position: relative;
      }
      &__grids {
        @include attachImage('grids', 718px, 269px);
        background-position-x: 7px;
      }
    }

    .cards {
      display: flex;
      justify-content: space-between;
      max-width: $container-width;
      position: relative;
      left: 4px;
      margin: 0 auto 50px;
      .card {
        box-shadow: 0px 10px 40px 0px $red-color11;
        height: 420px;
        display: inline-block;
        vertical-align: top;
        background: $red-color9;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        z-index: 2;
        transition: $transition;
        &:not(.card_is-touched) {
          &:hover {
            .card__frame-btc {
              transform: translate3d(-80px, 0, 0);
            }
            .card__frame-ltc {
              transform: translate3d(70px, -80px, 0);
            }
            &:after {
              height: 20%;
            }
          }
        }
        &__wrapper {
          display: inline-block;
          vertical-align: top;
          position: relative;
        }
        &__overlay {
          @include attachImage('card_overlay', 260px, 349px);
          position: absolute;
          bottom: -26px;
          left: 30px;
        }
        &_alerts {
          width: 310px;
          overflow: visible;
          .card__title {
            position: relative;
            z-index: 4;
            margin-top: 48px;
            margin-left: 36px;
          }
          .card__notice {
            position: absolute;
            z-index: 4;
            bottom: 39px;
            margin-left: 35px;
            line-height: 21px;
          }
          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            z-index: 3;
            background: linear-gradient(to top, $red-color9, $red-color13);
            width: 310px;
            height: 40%;
            filter: blur(10px);
            transition: $transition ease-in-out;
          }
        }
        &_multiple-ways {
          width: 310px;
          .card__title {
            margin-top: 47px;
            margin-left: 48px;
          }
          .card__notice {
            position: absolute;
            bottom: 43px;
            margin-left: 49px;
          }
          &:not(.card_is-touched) {
            &:hover {
              overflow: visible;
              .icon-hook {
                right: -48px;
              }
              .icon-sms {
                animation: swinging $transition;
              }
            }
          }
        }
        &_market-analytics {
          width: 310px;
          overflow: visible;
          .card__title {
            position: absolute;
            bottom: 36px;
            margin-left: 51px;
          }
          .card__notice {
            position: absolute;
            bottom: 143px;
            margin-left: 52px;
          }
          &:not(.card_is-touched) {
            &:hover {
              .card__market-frame,
              .card__ripple-frame {
                clip-path: inset(0 0 0 0%);
              }
            }
          }
        }
        &__title {
          @include font(42px, $white-color2, bold);
          letter-spacing: 0.7px;
          max-width: 200px;
          line-height: 48px;
        }
        &__notice {
          @include font(18px, $white-color2);
        }
        &__frame-btc {
          @include attachImage('frame_btc', 249px, 258px);
          position: absolute;
          z-index: 2;
          left: 17px;
          top: 77px;
          transition: $transition ease;
        }
        &__frame-ltc {
          @include attachImage('frame_ltc', 245px, 249px);
          position: absolute;
          z-index: 1;
          right: -16px;
          bottom: 13px;
          transition: $transition ease;
        }
        &__market-frame {
          margin-top: 5px;
          left: -76px;
          position: relative;
          z-index: 1;
          @include attachImage('market_frame', 318px, 152px);
          clip-path: inset(0 0 0 23.7%);
          transition: $transition;
        }
        &__ripple-frame {
          @include attachImage('ripple_frame', 333px, 129px);
          clip-path: inset(25% 21.5% 0 0);
          transition: $transition;
          position: absolute;
          top: -32px;
          right: -71px;
          @media (max-width: 1230px) {
            right: -56px;
          }
        }
        &__news-rising {
          @include attachImage('news-rising', 652px, 356px);
          max-width: 310px;
          height: 263px;
          background-position-x: -190px;
          background-position-y: -134px;
        }
      }
    }

    .text-break {
      &_top {
        display: block;
      }
      &_bottom {
        display: none;
      }
    }

    // styles for toggle cards on touchable devices
    .card_is-touched {
      &.card_show-effect {
        &.card_alerts {
          .card__frame-btc {
            transform: translate3d(-80px, 0, 0);
          }
          .card__frame-ltc {
            transform: translate3d(70px, -80px, 0);
          }
          &:after {
            height: 20%;
          }
        }
        &.card_multiple-ways {
          overflow: visible;
          .icon-hook {
            right: -48px;
          }
          .icon-sms {
            animation: swinging $transition;
          }
        }
        &.card_market-analytics {
          .card__market-frame,
          .card__ripple-frame {
            clip-path: inset(0 0 0 0%);
          }
        }
      }
    }

    .cover {
      @include attachImage('coverage', 100%, 402px);
      background-position-y: 9px;
      margin-top: 229px;
      position: relative;
      &__wrap {
        max-width: $container-width;
        position: relative;
        width: 100%;
        height: 100%;
        margin: auto;
      }
      &__red-circle {
        background: $red-color15;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        transform: skew(9deg);
        position: absolute;
        right: 81px;
        top: 52px;
      }
      $w: 714px;
      $h: 472px;
      &__alert {
        position: absolute;
        width: $w;
        height: $h;
        left: 0;
        margin-top: -70px;
      }
      &__hand {
        @include attachImage('hand-alert', $w, $h);
        z-index: 1;
        position: absolute;
      }
      &__description {
        max-width: 300px;
        position: absolute;
        right: 27px;
        top: -3px;
      }
      &__title {
        @include font(42px, $white-color2, bold);
        line-height: 47px;
        letter-spacing: 0.6px;
        margin-bottom: 25px;
        &_red {
          color: $red-color9;
          display: inline-block;
        }
      }
      &__notice {
        @include font(14px, $white-color6);
        line-height: 22px;
      }
      &__btn {
        @include font(12px, $white-color6, 500);
        @include removeBtnDefaults;
        margin-top: 44px;
        margin-left: 34px;
        text-transform: uppercase;
        position: relative;
        .pulsar-circle {
          width: 20px;
          height: 20px;
          border-radius: 25px;
          background: $red-color3;
          position: absolute;
          left: -31px;
          top: -3px;
          &:before,
          &:after {
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: $red-color3;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            margin: auto;
            transform: scale(0.5);
            transform-origin: center center;
          }
        }
        &:hover {
          .pulsar-circle {
            &:after,
            &:before {
              animation: pulse $transition*4 linear infinite;
            }
            &:after {
               animation-delay: $transition*2;
            }
          }
        }
      }
      &__btn-text {
        z-index: 1;
        position: relative;
      }
    }

    .control {
      position: relative;
      height: 825px;
      background: url("~src/assets/svg/ellipse.svg") no-repeat;
      background-position: 40.8% 6%;
      max-width: $container-width + 100;
      margin: auto;
      &__description {
        max-width: 300px;
        position: absolute;
        left: 56px;
        top: 82px;
      }
      &__title {
        @include font(42px, $white-color2, bold);
        line-height: 47px;
        letter-spacing: 0.6px;
        margin-bottom: 15px;
        &_red {
          color: $red-color9;
          display: inline-block;
        }
      }
      &__notice {
        @include font(14px, $white-color6);
        line-height: 22px;
      }
      $left: 465px;
      &__overview {
        position: absolute;
        left: $left;
        top: 87px;
      }
      &__overview-volume {
        margin-bottom: 33px;
      }
      &__overview-graph {
        display: inline-block;
        max-width: 164px;
        max-height: 52px;
      }
      &__overview-value {
        @include font(46px, $white-color6, bold);
        display: inline-block;
        vertical-align: top;
        margin-top: -4px;
        margin-left: 46px;
        letter-spacing: 0.5px;
      }
      &__overview-title {
        @include font(12px, $red-color10, bold);
        display: inline-block;
        vertical-align: top;
        margin-top: -4px;
        margin-left: 214px;
        letter-spacing: 0.1px;
      }
      .total-currencies {
        max-width: 530px;
        margin-top: 27px;
        &__value {
          @include font(80px, $white-color2, bold);
          letter-spacing: 1.6px;
          display: inline-block;
          vertical-align: top;
        }
        &__title {
          @include font(12px, $red-color10, bold);
          margin-top: -7px;
        }
        &__notice {
          @include font(14px, $white-color6);
          display: inline-block;
          max-width: 244px;
          margin-left: 16px;
          margin-top: 12px;
          line-height: 22px;
        }
      }

      .gainers-losers {
        position: absolute;
        top: 443px;
        left: 30px;
        border-radius: 6px;
        display: inline-block;
        background-color: $red-color12;
        box-shadow: 0px 10px 40px 0px $red-color11;
        &__table {
          padding: 15px 24px 0;
          background-color: $red-color9;
          border-radius: 6px;
        }
        &__td {
          line-height: 19px;
        }
        &__type {
          @include font(14px, $green-color3, 600);
        }
        &__name {
          @include font(14px, $white-color2, 500);
          @include trimOverflowText(131px);
          padding-left: 3px;
        }
        &__percent {
          @include font(24px, $white-color2, bold);
          padding-left: 27px;
          &:after {
            content: '%';
            @include font(16px, $white-color2, bold);
            margin-left: -2px;
            position: relative;
            top: -3px;
          }
          &_red {
            color: $red-color3;
          }
        }
        &__label {
          text-align: center;
          @include font(14px, $white-color2, 600);
          margin-top: 9px;
          background: $red-color10;
          padding: 7px 0;
          border-radius: 0 0 6px 6px;
        }
        .icon-arrow {
          position: relative;
          top: -6px;
          left: -4px;
          transform: scale(1.6);
        }
      }

      .recently-added {
        position: absolute;
        top: 443px;
        left: $left;
        border-radius: 6px;
        display: inline-block;
        background-color: $red-color12;
        box-shadow: 0px 10px 40px 0px $red-color11;
        &__table {
          padding: 13px 29px 0 29px;
          text-align: left;
        }
        &__th {
          @include font(10px, $white-color2);
          &_name {
            padding-left: 11px;
          }
        }
        &__td {
          line-height: 25px;
        }
        &__type {
          @include font(14px, $green-color3, bold);
        }
        &__name {
          @include font(14px, $white-color2, 500);
          @include trimOverflowText(113px);
          padding-left: 11px;
        }
        &__symbol {
          @include font(14px, $white-color2, 500);
        }
        &__price {
          @include font(18px, $white-color2, 600);
          padding-left: 27px;
          text-overflow: ellipsis;
          overflow-x: hidden;
          max-width: 217px;
        }
        &__volume {
          @include font(14px, $white-color2, 500);
          padding-left: 42px;
          text-overflow: ellipsis;
          overflow-x: hidden;
          max-width: 120px;
        }
        &__percent {
          @include font(14px, $white-color2, 500);
          padding-left: 34px;
          &:after {
            content: '%';
          }
        }
        &__label {
          text-align: center;
          @include font(14px, $white-color2, 600);
          margin-top: 9px;
          background: $red-color10;
          padding: 9px 0 6px;
          border-radius: 0 0 6px 6px;
        }
        &__th_name {
          width: 113px;
        }

        &__price,
        &__th_price {
          padding-left: 27px;
        }

        &__volume,
        &__th_volume {
          padding-left: 28px;
        }

        &__th_percent {
          padding-left: 23px;
          padding-right: 7px;
        }
        .icon-arrow {
          position: relative;
          top: -2px;
          left: -7px;
          transform: scale(1.5);
        }
      }
    }
    .currencies {
      // top: -149px;
      position: relative;
      padding-bottom: 0;
    }
  }
  .icon-sms {
    margin-top: 59px;
    margin-left: 30px;
  }
  .icon-web-alert {
    width: 180px;
    height: 180px;
    position: absolute;
    right: -33px;
    bottom: 48px;;
  }
  .icon-hook {
    transition: $transition;
    position: absolute;
    right: -64px;
    top: 115px;
  }

  @keyframes swinging {
    25% {
      transform: rotate(5deg);
    }
    50% {
      transform: rotate(-3deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @keyframes pulse {
    0%{
      transform: scale(0.5);
      opacity: 0;
    }
    50%{
      opacity: 0.15;
    }
    70%{
      opacity: 0.14;
    }
    100%{
      transform: scale(5);
      opacity: 0;
    }
  }

  @media only screen and (max-width : 1200px) {
    .homepage  {
      .cards {
        width: 100%;
        height: 470px;
        overflow-x: hidden;
        left: auto;
        .card__wrapper {
          height: 420px;
        }
      }
    }
  }

  @media  only screen and (max-width : 1150px) {
    .homepage {
      .cards {
        justify-content: space-around;
      }
    }
  }

  @media only screen and (max-width : 1095px) {
    .homepage {
      .control {
        &__overview,
        &__description,
        .gainers-losers,
        .recently-added {
          @include incrSelectorWeight(1) {
            position: static;
          }
        }
      }
      .currencies {
        height: auto;
        padding-bottom: 60px;
      }
    }
    .control {
      @include incrSelectorWeight(1) {
        display: flex;
        flex-flow: row wrap;
        height: auto;
        padding-top: 91px;
        margin-left: 58px;
        background-position: right -310px top -174px;
      }
      &__title {
        @include incrSelectorWeight(1) {
          font-size: 36px;
          line-height: 42px;
          margin-bottom: 21px;
        }
      }
      &__overview {
        max-width: 640px;
      }
      &__overview-volume {
        @include incrSelectorWeight(1) {
          margin-top: 55px;
          margin-bottom: 38px;
        }
      }
      &__overview-title {
        @include incrSelectorWeight(1) {
          margin-top: 2px;
          margin-left: 158px;
        }
      }
      &__overview-graph {
        @include incrSelectorWeight(1) {
          width: 164px;
          height: 50px;
          max-width: inherit;
          max-height: inherit;
          zoom: 0.66;
          margin-top: 10px;
        }
      }
      &__description {
        order: 0;
        margin-right: 12px;
      }
      &__overview,
      .recently-added {
        order: 2;
      }
      .gainers-losers {
        order: 0;
        max-height: 186px;
        margin-top: 2px;
        &__percent {
          padding-left: 37px;
        }
      }
      @include incrSelectorWeight(1) {
        .total-currencies {
          margin-left: 10px;
          margin-top: 27px;
          &__value {
            letter-spacing: 0.6px;
          }
          &__notice {
            margin-left: 6px;
            margin-top: 17px;
          }
        }
      }
    }
    .recently-added {
      margin-top: 49px;
      width: 100%;
      max-width: 655px;
    }
    .cards {
      @include incrSelectorWeight(1) {
        justify-content: initial;
        width: 100%;
        padding-left: 101px;
        height: 470px;
        overflow-x: auto;
        .card {
          &__wrapper {
            height: 420px;
          }
          &_multiple-ways,
          &_alerts {
            margin-right: 67px;
          }
        }
      }
    }
  }

  @media only screen and (max-width : 992px) {
    .head-title {
      @include incrSelectorWeight(1) {
        font-size: 36px;
        margin-bottom: 50px;
        line-height: 48px;
        span {
          padding-bottom: 1px;
        }
      }
    }
    .how-it-works {
      @include incrSelectorWeight(1) {
        margin-bottom: 112px;
      }
      &__title {
        @include incrSelectorWeight(2) {
        font-size: 36px;
        }
      }
      &__grids {
        margin: auto;
      }
      &__graph {
        @include incrSelectorWeight(1) {
          width: 100%;
          zoom: 0.95;
          margin: 66px auto 129px;
        }
      }
    }
    .cover {
      @include incrSelectorWeight(1) {
        margin-top: 274px;
        height: 302px;
      }
      &__red-circle {
        @include incrSelectorWeight(1) {
          width: 47px;
          height: 45px;
          right: 86px;
          top: 54px;
        }
      }
      &__hand {
        @include incrSelectorWeight(1) {
          @include attachImage('hand-alert_mobile', 463px, 472px);
          left: -59px;
          top: -100px;
        }
      }
      &__title {
        @include incrSelectorWeight(1) {
          font-size: 36px;
          line-height: 42px;
          letter-spacing: 0.1px;
          margin-bottom: 21px;
        }
      }
      &__notice {
        max-width: 250px;
      }
      &__btn {
        @include incrSelectorWeight(1) {
          margin-top: 42px;
          margin-left: 31px;
        }
      }
      &__description {
        @include incrSelectorWeight(1) {
          right: 60px;
          top: -99px;
        }
      }
    }
    .homepage {
      padding-top: 128px;
      &__free-alert-btn {
        @include incrSelectorWeight(1) {
          margin-bottom: 138px;
        }
      }
      .currencies {
        background: $red-color3;
      }
    }
    .pulsar {
      @include incrSelectorWeight(1) {
        right: 217px;
        top: -223px;
      }
    }
  }

  @media only screen and (max-width : 767px) {
    .homepage {
      padding-top: 60px;
      &__title {
        font-size: 12px;
      }
      &__free-alert-btn {
        @include incrSelectorWeight(1) {
          font-size: 13px;
          padding: 15px 0;
          margin-bottom: 110px;
          max-width: 150px;
        }
      }
      @include incrSelectorWeight(1) {
        .how-it-works,
        .recently-added,
        .total-currencies__notice {
            display: none;
        }
      }
      .head-title {
        font-size: 30px;
        line-height: 42px;
        margin-top: 44px;
        margin-bottom: 26px;
      }
      .cards {
        padding-left: calc((100vw - 310px)/2);
      }
      .cover {
        height: 347px;
        margin-top: 133px;
        &__alert {
          width: 100%;
        }
        &__red-circle {
          right: auto;
          left: 50px;
          top: 170px;
          width: 44px;
          height: 42px;
        }
        &__hand {
          background: none;
          width: initial;
          max-width: initial;
          height: initial;
        }
        &__wrap {
          max-width: 260px;
          margin: auto;
        }
        &__title {
          margin-bottom: 20px;
          line-height: 41px;
          z-index: 1;
          position: relative;
        }
        &__btn {
          margin-top: 36px;
          margin-left: 43px;
        }
        &__description {
          margin: 0;
          position: static;
        }
        &__btn-text {
          font-size: 16px;
        }
        .pulsar-circle {
          width: 24px;
          height: 24px;
          left: -42px;
          top: -4px;
        }
      }
      .control {
        padding: 78px 58px 0;
        margin-left: 0;
        margin-bottom: 58px;
        &__notice {
          max-width: 235px;
          hyphens: auto;
        }
        &__overview {
          max-width: 275px;
          margin: 0;
        }
        &__overview-value {
          font-size: 30px;
          margin-left: 1px;
          margin-top: 35px;
        }
        &__overview-volume {
          margin-top: 40px;
          margin-bottom: 28px;
        }
        &__overview-graph {
          max-width: initial;
          max-height: initial;
          zoom: 0.45;
          margin: -70px 0;
        }
        &__overview-title {
          font-size: 11px;
          margin-left: 1px;
          margin-top: 6px;
        }
        .gainers-losers {
          margin-left: 0;
          margin-top: 24px;
          width: 300px;
          &__td {
            padding: 1px 0;
          }
          &__name {
            padding-left: 3px;
            padding-right: 7px;
            max-width: 100px;
          }
          &__label {
            margin-top: -4px;
          }
          &__table {
            width: 100%;
            padding: 14px 0 14px 12px;
          }
          .icon-arrow {
            padding-right: 3px;
          }
        }
      }
      @include incrSelectorWeight(1) {
        .total-currencies {
          margin-top: 31px;
          margin-left: 0;
        }
        &__value {
          font-size: 80px;

        }
      }
      .currencies {
        .currencies-table {
          margin-top: 57px;
        }
      }
      .currencies-table {
        margin-top: 0;
      }
      .pulsar {
        right: auto;
        left: -190px;
        top: -110px;
      }
    }
  }

    @media only screen and (max-width : 740px) {
      .homepage {
        .control {
          flex-direction: column;
          padding: 78px 0 0 0;
          max-width: 260px;
          margin: 0 auto 58px;
          background: none;
          &__description {
            max-width: 275px;
          }
          &__overview {
            max-width: 290px;
          }
          &__overview-market-cap {
            min-width: 275px;
          }
          &__overview-graph {
            margin: -30px 0;
          }
          .gainers-losers {
            margin-top: 64px;
            width: 300px;
            margin-left: 0px;
            position: relative;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
          }
        }
      }
    }

  @media only screen and (max-width : 480px) {
    .homepage {
      .head-title {
        max-width: 400px;
      }
      .text-break {
        &_bottom {
          display: block;
        }
      }
      .cards {
        flex-direction: column;
        align-items: center;
        padding: 0;
        height: auto;
        overflow-x: hidden;
        .card {
          &_alerts,
          &_multiple-ways {
            margin-right: 0;
          }
          &__wrapper {
            height: auto;
            margin-bottom: 95px;
          }
        }
      }
    }
  }

  @media only screen and (max-width : 420px) {
    .homepage {
      .control {
        &__overview {
          max-width: 290px;
        }
      }
    }
  }

  _:-ms-lang(x), _:-webkit-full-screen, .card_market-analytics {
      overflow: hidden !important;
      &:hover {
        overflow: visible !important;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/landing/index.vue